/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import HeaderUserMenu from 'components/molecules/header_user_menu';
import { ProfileTypes } from 'store/modules/profile_store/types';
import LogoConlicitasegSimbolo from 'assets/images/header/logo-conlicitaseg-simbolo.svg';
import LogoConlicitasegTexto from 'assets/images/header/logo-conlicitaseg-texto.svg';
import LogoConlicitacao from 'assets/images/header/logo-conlicitacao.svg';

import { Nav } from './styles';

interface HeaderConlicitasegProps {
  offlineMode?: boolean;
}

/** Topo do usuário exclusivo do ConlicitaSeg (Figma Menu-ConlicitaSeg 19260:35833). */
const HeaderConlicitaseg: React.FC<HeaderConlicitasegProps> = ({ offlineMode = false }) => {
  const dispatch = useDispatch();
  const [isMyAccountOpen, setIsMyAccountOpen] = useState(false);

  useEffect(() => {
    if (offlineMode) return;
    dispatch({ type: ProfileTypes.UPDATE_STORE_FIELDS });
  }, []);

  return (
    <Nav className="d-flex align-items-center justify-content-between fixed-top mb-0 d-print-none">
      <Link
        to="/conlicitaseg"
        className="logo-conlicitaseg d-flex align-items-center"
        title="ConlicitaSeg"
      >
        <img className="logo-simbolo" src={LogoConlicitasegSimbolo} alt="" width="44" height="44" />
        <img
          className="logo-texto"
          src={LogoConlicitasegTexto}
          alt="conlicitaSeg"
          width="147"
          height="26"
        />
      </Link>
      <ul className="navbar-nav flex-row align-items-center">
        <li className="nav-item">
          <Link to="/painel" className="logo-conlicitacao d-flex" title="Conlicitação">
            <img src={LogoConlicitacao} alt="conlicitação" width="200" height="32" />
          </Link>
        </li>
        {!offlineMode && (
          <>
            <li className="nav-item d-md-inline-block d-none">
              <Link className="btn btn-primary tour-ajuda-button" to="/ajuda">
                Ajuda
              </Link>
            </li>
            <HeaderUserMenu
              isOpen={isMyAccountOpen}
              onToggle={() => setIsMyAccountOpen(!isMyAccountOpen)}
            />
          </>
        )}
      </ul>
    </Nav>
  );
};

export default HeaderConlicitaseg;
